// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"YO-z","carouselContainer":"ZO-z"};